// QA
// export const firebaseConfig = {
//     apiKey: "AIzaSyAv-A5juEeY4ax2FPOKht7T1-cNe0cKtKA",
//     authDomain: "infinity-production-tracker-qa.firebaseapp.com",
//     databaseURL: "https://infinity-production-tracker-qa.firebaseio.com",
//     projectId: "infinity-production-tracker-qa",
//     storageBucket: "infinity-production-tracker-qa.appspot.com",
//     messagingSenderId: "879751189760",
//     appId: "1:879751189760:web:8bb01adcc678868787cfe5",
//     measurementId: "G-77V1ZLGVQD"
//   };


// infinity-production-tracker orig project
export const firebaseConfig = {
    apiKey: process.env.REACT_APP_apiKey,
    authDomain: process.env.REACT_APP_authDomain,
    databaseURL: process.env.REACT_APP_databaseURL,
    projectId: process.env.REACT_APP_projectId,
    storageBucket: process.env.REACT_APP_storageBucket,
    messagingSenderId: process.env.REACT_APP_messagingSenderId,
    appId: process.env.REACT_APP_appId,
    measurementId: process.env.REACT_APP_measurementId
};


